<template>
  <view class="dialog-alert-passenger-demo">
    <cube-button  bind:click="onClickDialog">Dialog - alert</cube-button>
    <cube-dialog

      wx:ref="dialogAlert"
      title="我是标题"
      content="正文行文符合话术规范，表意清晰可多行展示，单行居中对齐，多行居左"
      confirmBtn="引导文案"
    ></cube-dialog>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  methods: {
    onClickDialog () {
      const dialogRef = this.$refs.dialogAlert
      dialogRef.show()
    }
  }
})
</script>

<style lang="stylus">

</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-dialog": "@mpxjs/mpx-cube-ui/src/components/dialog/index"
    }
  }
</script>

